<template>
  <div>
<!--        省市区地址-->
    <el-form ref="form" :model="form" :rules="rule_data">
      <el-row type="flex">
        <el-form-item prop="provinceNo" class="form-flex-item" :rules="[{
          required: required,
          message: '请输入省份',
          trigger: 'change'
          }]">
          <select-page
            v-model="form.provinceNo"
            class="areaSelect"
            :value="form.provinceNo"
            :request-data="{parentId: ''}"
            placeholder="请选择省"
            option-value="code"
            option-name="name"
            :pagination="false"
            :remote="false"
            valueName="province"
            requestUrl="addressList"
            :disabled="readOnly"
            @getSelect="setProv">
          </select-page>
        </el-form-item>
        <el-form-item prop="cityNo" class="form-flex-item" :rules="[{
          required: required,
          message: '请输入市级',
          trigger: 'change'
          }]">
          <select-page
            ref="child"
            v-model="form.cityNo"
            class="areaSelect"
            :value="form.cityNo"
            :request-data="cityReq"
            :multiple="multiCity"
            placeholder="请选择市"
            option-value="code"
            option-name="name"
            :disabled="readOnly"
            :pagination="false"
            :remote="false"
            valueName="city"
            @getSelect="setCity"
            requestUrl="addressList">
          </select-page>
        </el-form-item>
        <el-form-item prop="areaNo" class="form-flex-item" v-show="showArea" :rules="[{
          required: required && showArea,
          message: '请输入区域',
          trigger: 'change'
          }]">
          <select-page
            v-model="form.areaNo"
            class="areaSelect"
            :value="form.areaNo"
            :request-data="areaReq"
            placeholder="请选择区"
            option-value="code"
            option-name="name"
            :disabled="readOnly"
            :pagination="false"
            :remote="false"
            valueName="area"
            @getSelect="setArea"
            requestUrl="addressList">
            </select-page>
        </el-form-item>
        <el-form-item prop="address" class="form-input" v-show="showArea && showAddress">
          <el-input v-model="form.address" placeholder="详细地址需超过5个字，详细到门牌号" :disabled="readOnly"></el-input>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>

import selectPage from '@/components/selectPage'
export default {
  name: 'addressSelect',
  components: {
    selectPage
  },
  props: {
    value: {
      type: Object,
      default: function () {
        return {
          address: '',
          provinceName: '',
          provinceNo: '',
          cityName: '',
          cityNo: '',
          areaName: '',
          areaNo: ''
        }
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    showArea: {
      type: Boolean,
      default: true
    },
    multiCity: {
      type: Boolean,
      default: false
    },
    showAddress: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      form: {
        address: '',
        provinceName: '',
        provinceNo: '',
        cityName: '',
        cityNo: '',
        areaName: '',
        areaNo: ''
      },
      txt: '',
      rule_data: {
        address: [{
          validator: (rule, value, callback) => {
            if (!this.showArea || !this.showAddress) {
              callback()
            }
            if (this.required && value === '') {
              callback(new Error('请输入详细地址'))
            } else if (value !== '' && value !== undefined) {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?!^\w+$)^.{5,100}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入5-100位详细地址'))
              }
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }]
      },
      provinceReq: {}, // 银行网点省的请求数据
      cityReq: {},
      areaReq: {}
    }
  },
  mounted () {
    this.form = this.value
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.form = val
      },
      deep: true
    },
    form: {
      handler (val, oldVal) {
        this.$emit('getValue', val)
      },
      deep: true
    },
    'form.provinceNo': {
      handler (val) {
        if (val !== '') {
          this.cityReq = {
            parentId: val
          }
        } else {
          this.cityReq = {}
          this.$refs.child.selectList = []
        }
      }
    },
    'form.cityNo': {
      handler (val) {
        if (this.showArea) {
          if (val !== '') {
            this.areaReq = {
              parentId: val
            }
          } else {
            this.areaReq = {}
          }
        }
      }
    }
  },
  methods: {
    /**
     * 设置省
     */
    setProv (value) {
      this.form.provinceNo = (value && value.value) || ''
      this.form.provinceName = (value && value.name) || ''
      this.form.cityNo = ''
      this.form.cityName = ''
      this.form.areaNo = ''
      this.form.areaName = ''
      this.form.address = ''
    },
    /**
     * 设置市
     */
    setCity (value) {
      this.form.cityNo = (value && value.value) || ''
      this.form.cityName = (value && value.name) || ''
      if (this.showArea) {
        this.form.areaNo = ''
        this.form.areaName = ''
        this.form.address = ''
      }
    },
    /**
     * 设置区
     */
    setArea (value) {
      this.form.areaNo = (value && value.value) || ''
      this.form.areaName = (value && value.name) || ''
      this.form.address = ''
    }
  }
}
</script>

<style scoped>
    .form-input {
        width: 450px;
    }
    .form-flex-item {
        margin-right: 5px;
    }
</style>
